export default "__VITE_ASSET__ChrBw7Xb__"